<div class="icon-container">
    <ng-container>
        <div class="icon-item" (click)="showProformaReport()">
            <i class="pi pi-print icon"></i>
            <span class="icon-label">Proforma Invoice</span>
        </div>

        <div class="icon-item" (click)="showOrderReport()">
            <i class="pi pi-print icon"></i>
            <span class="icon-label">Sales Order</span>
        </div>
    </ng-container>
</div>